import React from 'react'

const Forward = ({ fill = 'white', height = 24 }) => (
  <svg width={height} height={height} viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 0C25.4605 3.45896 44 22.0495 44 22.0495L22.0198 44L20.0506 42.0317L38.298 23.3818H0V20.32H38.4106C38.4106 20.32 22.5631 4.49937 20.0308 1.96827L22 0Z" fill={fill} />
  </svg>)
export const ForwardIcon = React.memo(Forward)
